"use client";

import { Chip } from "@/components/ui/Chip";

import { ProductListingPageStoryblok } from "@/generated/sb/sb-types";
import { Link, usePathname } from "@/i18n/routing";
import { ISbStoryData } from "@storyblok/react/rsc";
import clsx from "clsx";
import styles from "./CategoryTags.module.css";

type Props = {
  categories: ISbStoryData<ProductListingPageStoryblok>[];
};

export const CategoryTags = ({ categories }: Props) => {
  const pathname = usePathname();

  return (
    <div className={styles.categoryTags}>
      {categories.map((category, index) => {
        // Remove locale prefix and leading/trailing slashes for comparison
        const cleanPathname = pathname
          .replace(/^\/[a-z]{2}(-[A-Z]{2})?\//, "/")
          .replace(/\/$/, "");
        const cleanCategorySlug = `/${category.full_slug.replace(/\/$/, "")}`;
        const isActive = cleanPathname === cleanCategorySlug;

        return (
          <Link
            href={category.full_slug}
            key={index}
            className={styles.tagLink}
          >
            <Chip className={clsx(styles.tag)} active={isActive}>
              <span>{category.content.title}</span>
            </Chip>
          </Link>
        );
      })}
    </div>
  );
};
